// Cyolena — static JS. Vanilla, no frameworks.

// Inline SVG icon set (lucide subset)
const ICONS = {
  truck:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M14 18V6H1v11h2"/><path d="M15 18H9"/><path d="M22 18h-3"/><path d="M14 9h4l3 4v5h-2"/><circle cx="6" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>',
  tag:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>',
  timer:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><line x1="10" y1="2" x2="14" y2="2"/><line x1="12" y1="14" x2="15" y2="11"/><circle cx="12" cy="14" r="8"/></svg>',
  bag:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>',
  star:'<svg viewBox="0 0 24 24" fill="currentColor"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
  sparkles:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l1.9 5.7L19 10l-5.1 1.3L12 17l-1.9-5.7L5 10l5.1-1.3z"/></svg>',
  gift:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>',
  check:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
  drops:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M7 16.3a4.07 4.07 0 0 1-1.7-7.74"/><path d="M12.56 6.6A10.97 10.97 0 0 1 18 5c0 .94-.21 1.84-.5 2.66"/><path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z"/></svg>',
  waves:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/><path d="M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/><path d="M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/></svg>',
  flower:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v3m0 0h3m-3 0H9m6 0a3 3 0 0 1-3 3m3-3a3 3 0 0 0 0 6m-6-9a3 3 0 0 0 3 3m-3-3a3 3 0 0 0 0 6m3-3v3"/><circle cx="12" cy="12" r="2"/></svg>',
  plus:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>',
  minus:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/></svg>',
  msg:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>',
  arrow:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>',
  shield:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>',
  rotate:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>',
  leaf:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19.2 2.96c1.4 9.43-1.32 14.6-8.2 17.04z"/><path d="M2 21c0-3 1.85-5.36 5.08-6"/></svg>',
  award:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="7"/><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/></svg>',
  flame:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/></svg>',
  eye:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>',
  checkc:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="9 12 11 14 15 10"/></svg>',
};

function icon(name, cls){ return `<svg-i class="${cls||''}">${ICONS[name]||''}</svg-i>`; }

// Hydrate [data-icon]
document.querySelectorAll('[data-icon]').forEach(el=>{
  const n=el.dataset.icon;
  if(ICONS[n]) el.innerHTML=ICONS[n];
});

// Countdown
function pad(n){return String(n).padStart(2,'0')}
function endOfToday(){const d=new Date();d.setHours(23,59,59,999);return d.getTime()}
const target=endOfToday();
function tickCountdowns(){
  const diff=Math.max(0,target-Date.now());
  const h=Math.floor(diff/3600000),m=Math.floor(diff%3600000/60000),s=Math.floor(diff%60000/1000);
  document.querySelectorAll('[data-countdown="compact"]').forEach(el=>{el.textContent=`${pad(h)}:${pad(m)}:${pad(s)}`});
  document.querySelectorAll('[data-countdown="full"]').forEach(el=>{
    el.innerHTML=`
      <div class="cd-box"><span class="cd-num">${pad(h)}</span><span class="cd-lbl">Hrs</span></div>
      <span class="cd-sep">:</span>
      <div class="cd-box"><span class="cd-num">${pad(m)}</span><span class="cd-lbl">Min</span></div>
      <span class="cd-sep">:</span>
      <div class="cd-box"><span class="cd-num">${pad(s)}</span><span class="cd-lbl">Sec</span></div>`;
  });
}
tickCountdowns();setInterval(tickCountdowns,1000);

// Reveal-on-scroll
const io=new IntersectionObserver((es)=>{es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.05,rootMargin:'0px 0px -5% 0px'});
document.querySelectorAll('.fade-in').forEach(el=>io.observe(el));
setTimeout(()=>document.querySelectorAll('.fade-in:not(.in)').forEach(el=>el.classList.add('in')),1500);

// FAQ accordion
document.querySelectorAll('.faq-item').forEach(item=>{
  const btn=item.querySelector('.faq-btn');
  btn?.addEventListener('click',()=>{
    const open=item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(i=>i.classList.remove('open'));
    if(!open) item.classList.add('open');
  });
});

// Social proof ticker
const events=[
  {name:"Priya",city:"Mumbai",product:"Vitamin C Serum",time:"2 min ago"},
  {name:"Ananya",city:"Delhi",product:"Rose Water Toner",time:"5 min ago"},
  {name:"Sneha",city:"Pune",product:"Cyolena Ritual Bundle",time:"8 min ago"},
  {name:"Kabir",city:"Bangalore",product:"Vitamin C Serum",time:"11 min ago"},
  {name:"Meera",city:"Chennai",product:"Rose Water Toner",time:"14 min ago"},
  {name:"Tanvi",city:"Kolkata",product:"Cyolena Ritual Bundle",time:"17 min ago"},
  {name:"Ayesha",city:"Hyderabad",product:"Vitamin C Serum",time:"21 min ago"},
];
const ticker=document.getElementById('socialTicker');
if(ticker){
  let i=0;
  function render(){
    const e=events[i%events.length];
    ticker.innerHTML=`<div class="card">
      <div class="ico">${ICONS.bag}</div>
      <div>
        <p style="margin:0;color:var(--charcoal)"><b>${e.name}</b> from ${e.city} bought</p>
        <p style="margin:0;color:rgba(0,0,0,.7)">${e.product}</p>
        <span class="meta">${ICONS.checkc} ${e.time}</span>
      </div></div>`;
  }
  setTimeout(()=>{ticker.classList.add('show');render();},4000);
  setInterval(()=>{i++;render();},5000);
}

// Stock bar viewers
const stockViewers=document.getElementById('stockViewers');
if(stockViewers){
  let v=28;
  setInterval(()=>{v=Math.max(18,Math.min(54,v+Math.floor(Math.random()*7)-3));stockViewers.textContent=v;},4000);
}

// ===== Product page =====
const PRODUCTS={
  "vitamin-c-serum":{
    slug:"vitamin-c-serum",name:"Vitamin C Brightening Serum",tagline:"Radiance, restored.",
    price:699,mrp:1299,size:"30 ml",rating:4.9,reviewCount:1240,soldCount:8500,
    description:"A potent brightening serum powered by stabilized Vitamin C, Niacinamide, Hyaluronic Acid and Vitamin E.",
    longDescription:"Cyolena's Vitamin C Serum is formulated with 10% stabilized L-Ascorbic Acid, 5% Niacinamide and Hyaluronic Acid to visibly fade dark spots, even out skin tone and restore a healthy, lit-from-within glow — without irritation.",
    ingredients:["Vitamin C 10%","Niacinamide 5%","Hyaluronic Acid","Vitamin E"],
    benefits:["Fades dark spots & pigmentation","Boosts natural radiance","Strengthens skin barrier","Lightweight, non-sticky finish"],
    howToUse:["Cleanse face with a gentle face wash.","Apply 3–4 drops on damp skin, AM or PM.","Follow with moisturiser & SPF in the morning."],
    images:["assets/cyolena-banner.jpg"],orb:"--orb-vitc",other:"rose-water-toner"
  },
  "rose-water-toner":{
    slug:"rose-water-toner",name:"Rose Water Facial Toner",tagline:"Hydration in a bottle.",
    price:499,mrp:899,size:"100 ml",rating:4.8,reviewCount:860,soldCount:5200,
    description:"A gentle, hydrating toner with pure Rose Water, Rice Water, Niacinamide and Aloe Vera.",
    longDescription:"Cyolena's Rose Water Toner balances pH, soothes redness and preps your skin to absorb serums better. Made with steam-distilled Damask Rose, fermented Rice Water and Hyaluronic Acid for a dewy, healthy finish.",
    ingredients:["Rose Water","Rice Water","Niacinamide","Hyaluronic Acid","Aloe Vera"],
    benefits:["Deep hydration & dewy glow","Calms redness and irritation","Tightens & refines pores","Preps skin for serum"],
    howToUse:["After cleansing, spray onto face & neck.","Gently pat in with fingertips.","Follow with your serum and moisturiser."],
    images:["assets/rose-toner-1.png","assets/rose-toner-3.png","assets/rose-toner-2.png"],orb:"--orb-rose",other:"vitamin-c-serum"
  }
};

function renderProduct(){
  const root=document.getElementById('pdpRoot');if(!root) return;
  const slug=new URLSearchParams(location.search).get('slug')||'vitamin-c-serum';
  const p=PRODUCTS[slug];
  if(!p){root.innerHTML='<div class="container" style="padding:120px 24px;text-align:center"><h1>Product not found</h1><a href="index.html" class="btn btn-primary" style="margin-top:16px">Back to home</a></div>';return}
  const o=PRODUCTS[p.other];
  const discount=Math.round((p.mrp-p.price)/p.mrp*100);
  document.title=p.name+' — Cyolena';

  root.innerHTML=`
  <section class="pdp">
    <div class="container">
      <nav class="crumbs"><a href="index.html">Home</a> / <a href="index.html#products">Shop</a> / <span style="color:var(--charcoal)">${p.name}</span></nav>
      <a href="index.html" class="back-link">${ICONS.arrow} Back to shop</a>

      <div class="pdp-grid">
        <div>
          <div class="gallery-main"><div class="glow" style="background:var(${p.orb})"></div><img id="galleryMain" src="${p.images[0]}" alt="${p.name}"/></div>
          ${p.images.length>1?`<div class="gallery-thumbs">${p.images.map((src,i)=>`<button data-idx="${i}" class="${i===0?'active':''}"><img src="${src}" alt=""></button>`).join('')}</div>`:''}
          <div class="trust-strip">
            <div class="item">${ICONS.truck}<b>Free Shipping</b>Orders ₹499+</div>
            <div class="item">${ICONS.rotate}<b>Easy Returns</b>7-day window</div>
            <div class="item">${ICONS.shield}<b>100% Authentic</b>Direct from brand</div>
          </div>
        </div>

        <div class="pdp-info">
          <p class="tagline">${p.tagline}</p>
          <h1>${p.name}</h1>
          <div class="pdp-rating">
            <div class="stars">${'<svg viewBox="0 0 24 24" fill="currentColor"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>'.repeat(5)}</div>
            <span><b>${p.rating}</b> · ${p.reviewCount.toLocaleString()}+ reviews</span>
            <span style="color:var(--muted-foreground);font-size:12px">· ${p.soldCount.toLocaleString()}+ sold</span>
          </div>
          <div class="pdp-price">
            <span class="now">₹<span id="totalPrice">${p.price}</span></span>
            <span class="mrp">₹${p.mrp}</span>
            <span class="off">${discount}% OFF</span>
          </div>
          <p class="tax-note">Inclusive of all taxes · ${p.size}</p>

          <div class="sale-mini">
            <div><p class="lbl">Sale ends in</p><p style="font-size:12px;color:rgba(250,248,245,.7);margin-top:4px">Don't miss this price</p></div>
            <div class="countdown" data-countdown="full"></div>
          </div>

          <div class="urgency">${ICONS.sparkles}<span><b>Selling fast!</b> 42 people bought this in the last 24 hours.</span></div>

          <div class="stockbar">
            <div class="row">
              <span class="left">${ICONS.flame} Only 17 left in stock!</span>
              <span class="right">${ICONS.eye} <b id="stockViewersPdp">28</b> people viewing</span>
            </div>
            <div class="bar"><div class="fill" style="width:34%"></div></div>
            <p class="note">Restocks in 2 weeks · Don't miss out</p>
          </div>

          <div class="tag-row">${p.ingredients.map(i=>`<span class="tag">${i}</span>`).join('')}</div>

          <button class="bundle" id="bundleBtn" type="button">
            <span class="box">${ICONS.check}</span>
            <span class="orb-sm" style="background:var(${o.orb})"></span>
            <span class="meta">
              <span class="k">Frequently bought together</span>
              <p style="margin:4px 0 0;font-size:14px;color:var(--charcoal);font-weight:500">Add ${o.name}</p>
              <p style="margin:0;font-size:12px;color:var(--muted-foreground)">Complete your ritual & save extra</p>
            </span>
            <span class="price-mini"><span class="strike">₹${o.price}</span><div class="add">+₹${o.price-200}</div></span>
          </button>

          <div class="qty-cta">
            <div class="qty">
              <button id="qtyMinus" aria-label="Decrease">${ICONS.minus}</button>
              <span id="qtyVal">1</span>
              <button id="qtyPlus" aria-label="Increase">${ICONS.plus}</button>
            </div>
            <button class="btn btn-primary buy-now" id="buyNow">Buy Now · ₹<span id="buyTotal">${p.price}</span></button>
          </div>
          <p class="savings">🎉 You save ₹<span id="savings">${p.mrp-p.price}</span> on this order</p>

          <div class="badge-row">
            <div class="badge-item">${ICONS.leaf}<span>Vegan</span></div>
            <div class="badge-item">${ICONS.shield}<span>Dermat Tested</span></div>
            <div class="badge-item">${ICONS.award}<span>Cruelty Free</span></div>
          </div>

          <div class="tabs">
            <button data-tab="description" class="active">Description</button>
            <button data-tab="ingredients">Ingredients</button>
            <button data-tab="how">How to use</button>
          </div>
          <div class="tab-content">
            <div class="tab-pane active" id="tab-description"><p>${p.longDescription}</p></div>
            <div class="tab-pane" id="tab-ingredients"><ul>${p.ingredients.map(i=>`<li>${ICONS.check} ${i}</li>`).join('')}</ul></div>
            <div class="tab-pane" id="tab-how"><ol>${p.howToUse.map((s,i)=>`<li><span class="num">0${i+1}</span>${s}</li>`).join('')}</ol></div>
          </div>

          <div class="love">
            <h3>Why you'll love it</h3>
            <ul>${p.benefits.map(b=>`<li>${ICONS.check} ${b}</li>`).join('')}</ul>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="mobile-buy">
    <div class="price"><div class="now">₹<span id="mobTotal">${p.price}</span></div><div class="mrp">₹${p.mrp}</div></div>
    <button class="btn btn-primary" onclick="document.getElementById('buyNow').click()">Buy Now</button>
  </div>`;

  // bind product page state
  const state={qty:1,bundle:false};
  const recalc=()=>{
    let total=p.price*state.qty;
    if(state.bundle) total+=o.price-200; // extra ₹200 off bundle
    const save=p.mrp*state.qty-p.price*state.qty + (state.bundle?200:0);
    document.getElementById('buyTotal').textContent=total;
    document.getElementById('mobTotal').textContent=total;
    document.getElementById('totalPrice').textContent=total;
    document.getElementById('savings').textContent=save;
  };
  document.getElementById('qtyMinus').onclick=()=>{state.qty=Math.max(1,state.qty-1);document.getElementById('qtyVal').textContent=state.qty;recalc();};
  document.getElementById('qtyPlus').onclick=()=>{state.qty+=1;document.getElementById('qtyVal').textContent=state.qty;recalc();};
  document.getElementById('bundleBtn').onclick=(e)=>{e.preventDefault();state.bundle=!state.bundle;document.getElementById('bundleBtn').classList.toggle('on',state.bundle);recalc();};
  document.getElementById('buyNow').onclick=()=>document.getElementById('checkoutModal').classList.add('show');

  // gallery thumbs
  document.querySelectorAll('.gallery-thumbs button').forEach(b=>{
    b.onclick=()=>{
      document.querySelectorAll('.gallery-thumbs button').forEach(x=>x.classList.remove('active'));
      b.classList.add('active');
      document.getElementById('galleryMain').src=p.images[+b.dataset.idx];
    };
  });

  // tabs
  document.querySelectorAll('.tabs button').forEach(b=>{
    b.onclick=()=>{
      document.querySelectorAll('.tabs button').forEach(x=>x.classList.remove('active'));
      document.querySelectorAll('.tab-pane').forEach(x=>x.classList.remove('active'));
      b.classList.add('active');
      document.getElementById('tab-'+b.dataset.tab).classList.add('active');
    };
  });

  // viewers count
  let v=28;setInterval(()=>{v=Math.max(18,Math.min(54,v+Math.floor(Math.random()*7)-3));const el=document.getElementById('stockViewersPdp');if(el) el.textContent=v;},4000);

  tickCountdowns();
}
renderProduct();

// Checkout modal handlers
document.querySelectorAll('[data-close-modal]').forEach(b=>b.addEventListener('click',()=>{
  document.querySelectorAll('.modal.show').forEach(m=>m.classList.remove('show'));
}));
document.getElementById('checkoutForm')?.addEventListener('submit',(e)=>{
  e.preventDefault();
  alert('Thank you! Your order has been placed. We will contact you shortly.');
  document.getElementById('checkoutModal').classList.remove('show');
  e.target.reset();
});
